import { Form, notification, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { coreApi } from "../../api/calls";

/**
 * Cities Sector
 * @component
 * @alias CitiesSelector
 * @property {number} initialValue - id of a city
 * @property {bool} required - sets Form Item required
 * @property {bool} readOnly - sets Form Item read-only
 * @property {string} mode - sets mode for Select component
 * @returns <Form.Item />
 */
const CitiesSelector = ({ initialValue, required, readOnly, onChange, mode = "multiple", defaultCitiesList = [], label = '' }) => {
  const { t } = useTranslation();

  const [cities, setCities] = useState(defaultCitiesList);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (defaultCitiesList.length !== 0) {
      return;
    }

    let isMounted = true;
    setLoading(true);

    coreApi
      .get("/cities")
      .then((response) => {
        if (isMounted) {
          setCities(response.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        notification.error({
          message: error.response.data.message,
        });
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Form.Item
      hasFeedback
      name="city_branches"
      label={ label || t("expansion.cityBranch") }
      rules={[
        {
          required: required,
          message: t("expansion.validation.city.required"),
        },
      ]}
      initialValue={initialValue}
    >
      <Select
        autoComplete={"off"}
        mode={mode}
        loading={loading}
        disabled={readOnly}
        showSearch
        placeholder={t("expansion.selectCities")}
        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        onChange={onChange}
      >
        {cities.map((city) => {
          return (
            <Select.Option key={city?.id} value={city?.id} data-country-branch-id={city.country_branch_id}>
              {city.name}
            </Select.Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};

export default CitiesSelector;
